import { render, staticRenderFns } from "./CmgOrderDiscounts.vue?vue&type=template&id=1f30cb54&scoped=true&lang=pug&"
import script from "./cmg-order-discounts.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-discounts.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderDiscounts.vue?vue&type=style&index=0&id=1f30cb54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30cb54",
  null
  
)

export default component.exports